const setConfig = function(){
  if(process.env.NODE_ENV == "development"){
    return  {
      clerk: {
        publishableKey: 'pk_test_aGVyb2ljLWJ1enphcmQtODMuY2xlcmsuYWNjb3VudHMuZGV2JA',
      },
      baseURL : 'https://dev.api.glxm.cleoma.fr/'
    }
  }
  if(process.env.NODE_ENV == "production"){
    return  {
      clerk: {
        publishableKey: 'pk_test_aGVyb2ljLWJ1enphcmQtODMuY2xlcmsuYWNjb3VudHMuZGV2JA',
      },
      baseURL : 'https://api.manage.galaxiemedia.fr/'
    }
  }
}

module.exports = setConfig()
